<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'DepositorySections',
    computed: {
      ...mapGetters('depository', [
        'getSectionsTree',
        'getSectionById'
      ])
    },
    render: function (createElement) {
      let sections = this.createSubMenu(this.getSectionsTree, createElement)
      return createElement('div', {
        class: 'depository-wrapper-menu'
      }, [
        createElement('el-menu', {
          on: {
            select: this.handleSelect
          }
        }, sections)
      ])
    },
    methods: {
      ...mapActions('depository', [
        'setSelectSection'
      ]),
      createSubMenu: function (sections, create) {
        let elements = []
        if (sections !== undefined && sections.length > 0) {
          sections.forEach(s => {
            if (s.sections.length > 0) {
              let sumMenu = create('el-submenu', {
                props: {
                  index: s.id + ''
                }
              }, [
                create('template', {
                  slot: 'title'
                }, [
                  create('span', s.name)
                ]),
                this.createSubMenu(s.sections, create)
              ])
              elements.push(sumMenu)
            } else {
              elements.push(create('el-menu-item', {
                props: {
                  index: s.id + ''
                }
              }, [s.name]))
            }
          })
        }

        return elements
      },
      handleSelect: function (key, keyPath) {
        let section = this.getSectionById(key)
        this.setSelectSection(section)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/DepositorySections.vue